import { VSInstanceInfo } from "../../store/appState";

const vsInstances: VSInstanceInfo[] = [
    {
        pid: 2650,
        title: "Visual Studio - Project 1"
    },
    {
        pid: 2824,
        title: "Visual Studio - Project 2 with a very very large name"
    },
    {
        pid: 259089,
        title: "Visual Studio - Project 3"
    },
    {
        pid: 25892,
        title: "Visual Studio - Project 4"
    }
];

export const newVSInstances: VSInstanceInfo[] = [
    {
        pid: 2525,
        title: "Visual Studio - Project 5"
    },
    {
        pid: 9820,
        title: "Visual Studio - Project 6"
    },
    {
        pid: 1250,
        title: "Visual Studio - Project 7"
    },
    {
        pid: 1860,
        title: "Visual Studio - Project 8"
    }
];

export default vsInstances;
